export default __webpack_public_path__ + "static/media/BUE_Logo.316c951f.png";